import { createClient } from '@supabase/supabase-js';

import { ENV } from '@/shared/config/env';

const supabaseUrl = ENV.SUPABASE_URL;
const supabaseAnonKey = ENV.SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'famecreator-auth-session',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    flowType: 'pkce', // Switched back to pkce for better session persistence
    debug: true, // Enable debug logs to trace session issues
  },
});
